import { render, staticRenderFns } from "./CreateEditDriver.vue?vue&type=template&id=e539da76"
import script from "./CreateEditDriver.vue?vue&type=script&lang=js"
export * from "./CreateEditDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports